import React from 'react';

import { Container } from '@legacy-vfuk/core-container';
import { PhotoAvatar } from '@legacy-vfuk/core-photo-avatar';
import { Heading } from '@legacy-vfuk/core-heading';
import { Paragraph } from '@legacy-vfuk/core-paragraph';
import { SimpleGrid } from '@legacy-vfuk/core-simple-grid';
import { Spacing } from '@legacy-vfuk/core-spacing';

import {
  Center,
  FeedBackWrapper,
  TestimonialContentWrapper,
} from './styles/Testimonial.styles';
import { TestimonialProps } from './types/Testimonial.types';
import RichText from '../../Elements/RichText';

const Testimonial: React.FC<TestimonialProps> = ({
  avatarImage,
  feedback,
  personJobTitle,
  personName,
  appearance,
}) => {
  return (
    <Container
      paddingLevel={avatarImage ? 6 : 3}
      appearance={appearance}
      elevation
    >
      <Center>
        <TestimonialContentWrapper
          isAvatar={avatarImage?.gatsbyImageData ? true : false}
        >
          {avatarImage?.gatsbyImageData && (
            <Spacing spacingLevel={{ bottom: 3 }}>
              <SimpleGrid justify="center">
                <PhotoAvatar
                  image={avatarImage.gatsbyImageData.images.fallback?.src || ''}
                  size={6}
                />
              </SimpleGrid>
            </Spacing>
          )}

          <Spacing spacingLevel={{ bottom: 3 }}>
            <Heading level={4}>
              <FeedBackWrapper>
                <RichText text={feedback} />
              </FeedBackWrapper>
            </Heading>
          </Spacing>

          <div>
            <Paragraph size={2} weight={3} noMargin>
              {personName}
            </Paragraph>

            <Paragraph size={1} weight={2}>
              {personJobTitle}
            </Paragraph>
          </div>
        </TestimonialContentWrapper>
      </Center>
    </Container>
  );
};

export default Testimonial;
